import gql from 'graphql-tag';
import { ListingsCollection } from '@reverbdotcom/commons/src/components/listings_collection';

export const mixedFeedFragment = gql`
  fragment MixedFeedRow on reverb_feed_FeedEntry {
    id
    type
    deleted
    metadata {
      sourceType
    }
    localizedContents {
      locale
      title
      shortDescription
    }
    entry {
      ... on Article {
        _id
        id
        title
        images(
          input: {
            count: 1
            scope: "full_bleed_image"
            transform: "card_square"
          }
        ) {
          source
        }
        webLink {
          href
        }
        articleCategories {
          name
          slug
        }
      }
      ... on Listing {
        _id
        ...ListingsCollection
      }
    }
  }

  ${ListingsCollection.fragments.listing}
`;

